import {NavLink, Link} from "react-router-dom"
import {useTranslation} from "react-i18next"
import neurowideStudioLogo from "../../assets/neurowide-studio.svg"
import neurowideStudioMin from "../../assets/neurowide-studio-min.svg"
import doubleArrowLeftIcon from "../../assets/icon/double-arrow-left.svg"
import homeNavIcon from "../../assets/icon/home-nav.svg"
import stNavIcon from "../../assets/icon/subtitles.svg"
import ecpNavIcon from "../../assets/icon/projects-nav.svg"
import lexiconsNavIcon from "../../assets/icon/lexicons-nav.svg"
import manageAccountIcon from "../../assets/icon/manage-account.svg"
import teamNavIcon from "../../assets/icon/team-nav.svg"
import nolejLogo from "../../assets/img/nolej-logo.svg"
import helpIcon from "../../assets/icon/help.svg"
import creditsNavIcon from "../../assets/icon/credits-nav.svg"
import RequiredStLicence from "../../tools/RequireStLicence"
import RequireIsManager from "../../tools/RequireIsManager"
import RequireIsAdmin from "../../tools/RequireIsAdmin"
import GetFirstSegment from "../../tools/GetFirstSegment"
import {useLocation} from "react-router-dom"
import useTeam from "../../swrCustomHooks/useTeam"
import {useLocalContext} from "../../reactContext/contextCustomHooks/useLocalContext"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"

export default function MainNavigation() {
    const {t} = useTranslation()
    const {localContext, setLocalAction} = useLocalContext()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    let location = useLocation()
    const firstSegment = GetFirstSegment(location.pathname)
    const {team, isLoadingTeam, isErrorTeam} = useTeam(sessionContext.idTeam)

    const handleClick = () => {
        setLocalAction({
            type: "HANDLE_NAVIGATION",
            payload: {
                minNavigation: !localContext.minNavigation,
            }
        })
    }

    if (sessionContext.role !== "admin" && (isLoadingTeam || isErrorTeam || team.message)) return null
    return (
        <>
        <div className={`SECTION ${localContext.minNavigation ? "MIN-NW-LEFT-NAV" : "NW-LEFT-NAV"}`}>
            <img className="nw-logo" src={localContext.minNavigation ? neurowideStudioMin : neurowideStudioLogo} alt=""/>
            <img onClick={handleClick} className="nav-action-btn" src={doubleArrowLeftIcon} alt="" title={localContext.minNavigation ? t("Expand navigation menu") : t("Collapse navigation menu")}/>
            <span className="line"></span>
            <nav>
                <ul className="top-nav">
                    {sessionContext.role === "admin" ?
                        <>
                        <RequireIsAdmin role={sessionContext.role}>
                            <li><NavLink to="/neurowide-dashboard"><img src={manageAccountIcon} alt=""/><span>{t("Neurowide dashboard")}</span></NavLink></li>
                        </RequireIsAdmin>
                        </>
                        :
                        <>
                        <li title={t("Homepage")}><NavLink to="/" className="navlink"><img src={homeNavIcon} alt=""/><span>{t("Home")}</span></NavLink></li>
                        {teamContext.licenceTypes.includes("st") && <li title={t("Subtitling Projects")}><NavLink to="/st/projects" className="navlink"><img src={stNavIcon} alt=""/><span>{t("ST Projects")}</span></NavLink></li>}
                        {teamContext.licenceTypes.includes("ecp") && <li title={t("ECP Projects")}><NavLink to="/ecp/projects" className="navlink"><img src={ecpNavIcon} alt=""/><span>{t("ECP Projects")}</span></NavLink></li>}
                        <RequiredStLicence types={teamContext.licenceTypes}>
                            <li title={t("Lexicons")}><NavLink to="/lexicons" className="navlink"><img src={lexiconsNavIcon} alt=""/><span>{t("Lexicons")}</span></NavLink></li>
                        </RequiredStLicence>
                        <RequireIsManager role={sessionContext.role}>
                            <li title={t("Team management")}><NavLink to="/team-management" className="navlink"><img src={teamNavIcon} alt=""/><span>{t("Team management")}</span></NavLink></li>
                        </RequireIsManager>
                        {(teamContext.licencePackage && teamContext.licencePackage.url_label === "Nolej" && teamContext.licencePackage.url !== "") &&
                            <>
                            <span className="second-line"></span>
                            <li title={t("Nolej")} className="nolej-btn"><a href={teamContext.licencePackage.url} target="_blank" rel="noreferrer"><img className="nolej-logo" src={nolejLogo} alt=""/></a></li>
                            </>
                        }
                        </>
                    }
                </ul>
                <ul className="bottom-nav">
                    <li className="help" title={t("Help")}><Link to="/help"><img src={helpIcon} alt=""/><span>{t("Help")}</span></Link></li>
                    {(firstSegment === "st" || firstSegment === "ecp") &&
                        <li className="credit" title={t("Your credits")}>
                            <Link to="/"><img src={creditsNavIcon} alt=""/>
                                <span>{`${firstSegment === "st" ? team.team.nb_credits : firstSegment === "ecp" ? team.team.nb_credits_ecp : null}
                                ${t((firstSegment === "st" && team.team.nb_credits > 1) ? t("credits available") : (firstSegment === "ecp" && team.team.nb_credits_ecp > 1) ? t("credits available") : t("credit available"))}`}</span>
                            </Link>
                        </li>
                    }
                </ul>
            </nav>
        </div>
        </>
    )
}